<template>
  <div class="bg-card rounded p-4 border">
    <vs-button size="large" transparent class="m-0 mb-3" :to="`/helex/Ayuda/Academia/AcademiaVideos/${InfoEvaluacion.cursoId}`">
      <i class="fas fa-chevron-left mr-1"></i> Volver al curso
    </vs-button>
    <!-- Título del cuestionario -->
    <h1 class="titulo-cuestionario">{{ InfoEvaluacion.tituloCuestionario }}</h1>

    <!-- Detalles del cuestionario -->
    <div class="InformacionFechas bg-dark">
      <p><strong>Abrió:</strong> {{ InfoEvaluacion.fechaApertura }}</p>
      <p><strong>Cierra:</strong> {{ InfoEvaluacion.fechaCierre }}</p>
    </div>
    <b-button style="margin-top: 20px" @click="IniciarCuestionario" :disabled="!InfoEvaluacion.habilitada" >
      {{intentos.length !== 0 ? "Reintentar cuestionario" : "Intentar cuestionario"}}
    </b-button>

    <!-- Calificación más alta -->
    <div style="margin-top: 20px; margin-left: 10px">
      <!-- <p><strong>Intentos permitidos:</strong> {{ intentosPermitidos }}</p>-->
      <p><strong>Límite de tiempo:</strong> {{ InfoEvaluacion.limiteTiempo }} minutos</p>
      <p><strong>Intentos permitidos:</strong> {{ InfoEvaluacion.NumeroIntentos }}</p>
      <p><strong>Método de calificación:</strong> {{ InfoEvaluacion.metodoCalificacion }}</p>
      <p><strong>Calificación para aprobar: </strong> {{ InfoEvaluacion.calificacionMinima }} de {{InfoEvaluacion.calificacionMaxima}}</p>
    </div>

    <div v-if="intentos.length !== 0" class="calificacion-mas-alta">
      <h4>Calificación más alta: {{ InfoEvaluacion.calificacionMasAlta }} / {{ InfoEvaluacion.calificacionMaxima }}</h4>
    </div>

    <!-- Lista de intentos -->
    <div v-if="intentos.length !== 0">
      <h3>Tus intentos {{ intentos.length }}/{{ InfoEvaluacion.NumeroIntentos }}</h3>
      <div class="intentos p-2">
        <li v-for="(intento, index) in intentos" :key="index" class="bg-dark p-3 border rounded  mt-2 col-3">
          <p><strong>Estado:</strong> {{ intento.estado }}</p>
          <p><strong>Iniciado:</strong> {{ intento.fechaInicio }}</p>
          <p><strong>Finalizado:</strong> {{ intento.fechaFin }}</p>
          <p><strong>Duración:</strong> {{ intento.duracion }}</p>
          <p><strong>Puntaje:</strong> {{ intento.puntaje }}</p>
          <p><strong>Calificación:</strong> {{ intento.calificacion }}</p>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "InformacionEvaluaciones",
  data() {
    return {
      persona: {},
      InfoEvaluacion:{},
      intentos: [],
      evaluacionId: null,
      cursoId: null
    };
  },
  async mounted(){
    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.evaluacionId = this.$route.params.id;
    await this.getData(this.evaluacionId);
  },
  methods: {
    async IniciarCuestionario() {
      await Swal.fire({
        title: '¿Desas Realizar la Evaluación?',
        text: `¡Recuerda que tienes ${this.InfoEvaluacion.limiteTiempo} minutos para responder ${this.InfoEvaluacion.CantidadPreguntas} preguntas!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Iniciar Evaluación!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.$router.push(`/helex/Ayuda/Academia/Evaluacion/${this.evaluacionId}`)
        }
      })
    },
    async getData(evaluacionId){
      try {
        await this.$store.dispatch('hl_get',{
          path: `EvaluacionesAcademia/ObtenerIntentosEvaluacion/${evaluacionId}/persona/${this.persona.id}`,
        }).then(res => {
          if (res.respuesta){
            this.InfoEvaluacion = res.data.InfoEvaluacion;
            this.intentos = res.data.Intentos;
          }
        })
      }catch (error){
        console.log("error:"+error)
      }
    }
  },
};
</script>

<style scoped>
.InformacionFechas {
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 10px;
  /* background-color: rgba(185, 185, 185, 0.22); */
}

.InformacionFechas p {
  margin: 5px 0;
}


/* Estilo general */
/* .contenedor-cuestionario {
  font-family: Arial, sans-serif;
  margin: 20px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  background-color: #f9f9f9;
} */

.titulo-cuestionario {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.detalles-cuestionario p,
.intentos p {
  margin: 5px 0;
}

.calificacion-mas-alta {
  margin: 20px 0;
  font-size: 18px;
  font-weight: bold;
}

.intentos {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
}

.intento {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fff;
  width: 350px;
  margin: 5px;
}
</style>
